import { render } from "./CreditVoucherList.vue?vue&type=template&id=2dfd839a"
import script from "./CreditVoucherList.vue?vue&type=script&lang=js"
export * from "./CreditVoucherList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__